<template>
    <router-view @videoSelected="handleVideoSelected" @spanSelected="handleSpanSelected"></router-view>
</template>
<script setup>

// 定义组件
import {useRouter, useRoute} from 'vue-router'


import { ref,onMounted } from 'vue'

const router = useRouter()  

// //初始显示路由 clipper/kol/select
// onMounted(() => {
//   router.push('kol/select')
// })




// 定义数据
// 用户的搜索关键词
// 用户可访问的视频列表
// 用户当前选择的视频，即待编辑视频
// 用户当前选择的视频片段，即待编辑视频片段


const handleVideoSelected = (video) => {
      // 当 'videoSelected' 事件被触发时，这个函数将被调用
      // 清掉route历史记录
      router.replace('para')
    }

const handleSpanSelected = (spans) => {
      // 当 'spanSelected' 事件被触发时，这个函数将被调用
      console.log("The span has been selected: ", spans)
      router.push('word')
    }



  

 

</script>